import Field from "@mirage/components/regularField/Field";
import Grid from "@mui/material/Grid";
import { IPlanningApplicationDetails } from "@shared/publicportal/contracts/IPlanningApplicationDetails";
import React from "react";
import "../PlanningApplication.css";

interface PASummaryTabContentProps {
    planningApp: IPlanningApplicationDetails | null;
    loading: boolean;
}

const PASummaryTabContent: React.FC<PASummaryTabContentProps> = (props) => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={6} lg={6} xl={6}>
                <Grid item>
                    <Field label="Reference" mode="view" value={props.planningApp?.name} isLoading={props.loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Initial Reference" mode="view" value={props.planningApp?.initialAppRef} isLoading={props.loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Application Type" mode="view" value={props.planningApp?.applicationType?.name} isLoading={props.loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Received Date" mode="view" value={props.planningApp?.receivedDate} isLoading={props.loading} contentType="DATE" />
                </Grid>
                <Grid item>
                    <Field label="Registered Date" mode="view" value={props.planningApp?.registeredDate} isLoading={props.loading} contentType="DATE" />
                </Grid>
                <Grid item>
                    <Field label="Proposal Details" mode="view" value={props.planningApp?.proposal} isLoading={props.loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Case Officer" mode="view" value={props.planningApp?.caseOfficer?.name} isLoading={props.loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Status" mode="view" value={props.planningApp?.applicationStatus} isLoading={props.loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Decision" mode="view" value={props.planningApp?.decision} isLoading={props.loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Decision Level" mode="view" value={props.planningApp?.decisionLevel} isLoading={props.loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Appeal Decision" mode="view" value={props.planningApp?.appealDecision} isLoading={props.loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Address" mode="view" value={`${props.planningApp?.location}`} isLoading={props.loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Ward" mode="view" value={props.planningApp?.ward} isLoading={props.loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Parish" mode="view" value={props.planningApp?.parish} isLoading={props.loading} contentType="TEXT" />
                </Grid>
            </Grid>
            <Grid item xs={12} md={6} lg={6} xl={6}>
                <Grid item>
                    <Field label="Applicant Name" mode="view" value={props.planningApp?.applicantFullName} isLoading={props.loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Applicant Address" mode="view" value={props.planningApp?.applicantAddress} isLoading={props.loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field
                        label="Environmental Statement Required"
                        mode="view"
                        value={props.planningApp?.environmentalStatementRequired}
                        isLoading={props.loading}
                        contentType="CHECKBOX"
                    />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default React.memo(PASummaryTabContent);
